module.exports = __webpack_public_path__ + "media/V63.8ea7d0ac.mp4";